import React from 'react';
import { TextField, makeStyles, useTheme } from '@material-ui/core';
import { t } from 'ttag';
import { GreenSwitch } from '@coolremote/shared';
import addEditScheduleStyles from '../addEditSchedule.style';

const useDefaultStyles = makeStyles(addEditScheduleStyles);

interface ScheduleNameRowProps {
  /** The current name of the schedule */
  name: string;
  /** Callback triggered when the name changes */
  onNameChange: (newName: string) => void;
  /** Whether the schedule is disabled */
  disabled: boolean;
  /** Callback triggered when the disabled status toggles */
  onDisabledChange: () => void;
  /** Optional classes to override default styles */
  classes?: any;
}

/**
 * A row component for editing the schedule name and its active/disabled status.
 */
const ScheduleNameRow: React.FC<ScheduleNameRowProps> = ({
  name,
  onNameChange,
  disabled,
  onDisabledChange,
  classes: providedClasses,
}) => {
  const defaultClasses = useDefaultStyles();
  const classes = providedClasses || defaultClasses;
  const theme: any = useTheme();

  return (
    <div className={classes.bodyRow}>
      <TextField
        variant="outlined"
        label={t`Schedule Name`}
        placeholder={name ? '' : t`Schedule Name`}
        value={name}
        className={classes.inputClass}
        onChange={(e) => onNameChange(e.target.value)}
        InputLabelProps={{ shrink: !!name }}
      />
      <div className={classes.controlSec}>
        <GreenSwitch
          checked={!disabled}
          onChange={onDisabledChange}
          color={theme.palette.colors?.switchPower?.colorChecked || theme.palette.colors?.switch?.colorChecked}
          uncheckedColor={theme.palette.colors?.switchPower?.color || theme.palette.colors?.switch?.color}
        />
      </div>
    </div>
  );
};

export default ScheduleNameRow;
